<div class="input-container">
  <label for="{{ id }}">{{ label }}</label>
  <input type="{{ type }}" [id]="id" [formControl]="control" [placeholder]="placeholder"
    [class.ng-invalid]="control.invalid && control.touched" (keydown)="handleKeyDown($event)"
    (input)="handleInput($event)" />
  <div *ngIf="control.invalid && control.touched" class="error-message">
    <div *ngIf="control.errors?.['required']">{{ 'general_validation.required' | i18nextEager }} *</div>
    <div *ngIf="control.errors?.['taxIdInvalid']" class="error-message">
      {{ 'general_validation.taxIdInvalid' | i18nextEager: { number: (minNum === maxNum ? minNum : minNum + "-" +
      maxNum) } }}
    </div>
    <div *ngIf="control.errors?.['bankNumberInvalid']" class="error-message">
      {{ 'general_validation.bankNumberInvalid' | i18nextEager: { number: (minNum === maxNum ? minNum : minNum + "-" +
      maxNum) } }}
    </div>
    <div *ngIf="control.errors?.['other']">{{ errorMessage }}</div>
  </div>
</div>